export default {
  "advent": {
    "season": "Avvento",
    "feria": "{{day}} della {{week}} settimana di Avvento",
    "sunday":  "{{week}} Domenica di Avvento"
  },
  "christmastide": {
    "season": "Natale",
    "day": "{{day}} di Natale",
    "octave": "{{count}} giorno dell'Ottava di Natale",
    "sunday": "{{count}} Domenica di Natale"
  },
  "epiphany": {
    "season": "Epifania",
    "before": "{{day}} prima dell'Epifania",
    "after": "{{day}} dopo l'Epifania"
  },
  "ordinaryTime": {
    "season": "Tempo Ordinario",
    "feria": "{{day}} della {{week}} settimana del Tempo Ordinario",
    "sunday": "{{week}} Domenica del Tempo Ordinario"
  },
  "lent": {
    "season": "Quaresima",
    "feria": "{{day}} della {{week}} settimana di Quaresima",
    "sunday": "{{week}} Domenica di Quaresima",
    "day_after_ash_wed": "{{day}} dopo Mercoledí delle Ceneri"
  },
  "holyWeek": {
    "season": "Settimana Santa",
    "feria": "{{day}} della Settimana Santa"
  },
  "eastertide": {
    "season": "Pasqua",
    "feria": "{{day}} della {{week}} settimana di Pasqua",
    "sunday":  "{{week}} Domenica di Pasqua",
    "octave": "{{day}} di Pasqua"
  },
  "celebrations": {
    "allSaints": "Tutti i Santi",
    "annunciation": "Annunciazione del Signore",
    "ascension": "Ascensione del Signore",
    "ashWednesday": "Mercoledí delle Ceneri",
    "assumption": "Assunzione della Beata Vergine Maria",
    "baptismOfTheLord": "Battesimo del Signore",
    "birthOfJohnTheBaptist": "Nativitá di San Giovanni Battista",
    "christmas": "Natale del Signore",
    "christTheKing": "Cristo Re dell'universo",
    "corpusChristi": "Santissimo Corpo e Sangue di Cristo",
    "divineMercySunday": "2º Domenica di Pasqua / Divina Misericordia",
    "easter": "Domenica di Pasqua",
    "epiphany": "Epifania del Signore",
    "goodFriday": "Venerdí Santo",
    "holyFamily": "Santa Famiglia di Gesú, Maria e Giuseppe",
    "holySaturday": "Sabato Santo / Vigilia di Pasqua",
    "holyThursday": "Giovedí Santo",
    "immaculateConception": "Immacolata Concezione della Beata Vergine Maria",
    "immaculateHeartOfMary": "Cuore Immacolato della Beata Vergine Maria",
    "josephHusbandOfMary": "San Giuseppe, sposo della Beata Vergine Maria",
    "maryMotherOfGod": "Maria Santissima Madre di Dio",
    "palmSunday": "Domenica delle Palme",
    "pentecostSunday": "Domenica di Pentecoste",
    "peterAndPaulApostles": "Santi Pietro e Paolo, apostoli",
    "presentationOfTheLord": "Presentazione del Signore",
    "sacredHeartOfJesus": "Sacratissimo Cuore di Gesù",
    "theExaltationOfTheHolyCross": "Esaltazione della Santa Croce",
    "transfiguration": "Trasfigurazione del Signore",
    "trinitySunday": "Santissima Trinitá"
  },
  "sanctoral": {
    "allSouls": "Commemorazione di tutti i fedeli defunti",
    "birthOfTheBlessedVirginMary": "Nativitá della Beata Vergine Maria",
    "chairOfSaintPeterApostle": "Cattedra di San Pietro apostolo",
    "conversionOfSaintPaulApostle": "Conversione di San Paolo apostolo",
    "dedicationOfTheBasilicaOfSaintMaryMajor": "Dedicazione della Basilica di Santa Maria Maggiore",
    "dedicationOfTheBasilicasOfSaintsPeterAndPaulApostles": "Dedicazione delle Basiliche dei Santi Pietro e Paolo apostoli",
    "dedicationOfTheLateranBasilica": "Dedicazione della basilica Lateranense",
    "firstMartyrsOfTheChurchOfRome": "Santi Primi Martiri della Chiesa Romana",
    "guardianAngels": "Santi Angeli Custodi",
    "holyInnocentsMartyrs": "Santi Innocenti, martiri",
    "holyNameOfTheBlessedVirginMary": "Santissimo Nome di Maria",
    "maryMotherOfTheChurch": "Beata Vergine Maria Madre della Chiesa",
    "ourLadyOfFatima": "Beata Vergine Maria di Fatima",
    "ourLadyOfGuadalupe": "Beata Vergine Maria di Guadalupe",
    "ourLadyOfLourdes": "Beata Vergine Maria di Lourdes",
    "ourLadyOfMountCarmel": "Beata Vergine Maria del Carmelo",
    "ourLadyOfSorrows": "Beata Vergine Maria Addolorata",
    "ourLadyOfTheRosary": "Beata Vergine Maria del Rosario",
    "popeSaintJohnPaulII": "San Giovanni Paolo II, papa",
    "popeSaintJohnXXIII": "San Giovanni XXIII, papa",
    "presentationOfTheBlessedVirginMary": "Presentazione della Beata Vergine Maria",
    "queenshipOfBlessedVirginMary": "Beata Vergine Maria regina",
    "saintAgathaVirginAndMartyr": "Sant'Agata, vergine e martire",
    "saintAgnesVirginAndMartyr": "Sant'Agnese, vergine e martire",
    "saintAlbertTheGreatBishopAndDoctor": "Sant'Alberto Magno, vescovo e dottore della Chiesa",
    "saintAloysiusGonzagaReligious": "San Luigi Gonzaga, religioso",
    "saintAlphonsusMariaDeLiguoriBishopAndDoctorOfTheChurch": "Sant'Alfonso Maria de Liguori, vescovo e dottore della Chiesa",
    "saintAmbroseBishopAndDoctor": "Sant'Ambrogio, vescovo e dottore della Chiesa",
    "saintAndrewDungLacAndCompanionsMartyrs": "Santi Andrea Dung-Lac, sacerdote e compagni, martiri",
    "saintAndrewKimTaegonPriestAndPaulChongHasangAndCompanionsMartyrs": "Sant Andrea Kim Taegon, Paolo Chong Hasang e compagni, martiri",
    "saintAndrewTheApostle": "Sant'Andrea, apostolo",
    "saintAngelaMericiVirgin": "Sant'Angela Merici, vergine",
    "saintAnselmOfCanterburyBishopAndDoctorOfTheChurch": "Sant'Anselmo, vescovo e dottore della Chiesa",
    "saintAnthonyMaryClaretBishop": "Sant'Antonio Marla Claret, vescovo",
    "saintAnthonyOfEgyptAbbot": "Sant'Antonio, abate",
    "saintAnthonyOfPaduaPriestAndDoctor": "Sant'Antonio di Padova, sacerdote e dottore della Chiesa",
    "saintAnthonyZaccariaPriest": "Sant'Antonio Maria Zaccaria, sacerdote",
    "saintApollinaris": "Sant'Apollinare, vescovo e martire",
    "saintAthanasiusBishopAndDoctor": "Sant'Atanasio, vescovo e dottore della Chiesa",
    "saintAugustineOfCanterburyBishop": "Sant'Agostino di Canterbury, vescovo",
    "saintAugustineOfHippoBishopAndDoctorOfTheChurch": "Sant'Agostino, vescovo e dottore della Chiesa",
    "saintBarnabasTheApostle": "San Barnaba, apostolo",
    "saintBartholomewTheApostle": "San Bartolomeo, apostolo",
    "saintBedeTheVenerablePriestAndDoctorSaintGregoryViiPopeSaintMaryMagdaleneDePazziVirgin": "San Beda Venerabile, sacerdote e dottore della Chiesa / San Gregorio VII, papa / Santa Maria Maddalena de’ Pazzi, vergine",
    "saintBenedictOfNursiaAbbot": "San Benedetto, abate, patrono d'Europa",
    "saintBernardineOfSienaPriest": "San Bernardino da Siena, sacerdote",
    "saintBernardOfClairvauxAbbotAndDoctorOfTheChurch": "San Bernardo, abate e dottore della Chiesa",
    "saintBlaseBishopAndMartyrSaintAnsgarBishop": "San Biagio, vescovo e martire / Sant’Ansgario, vescovo",
    "saintBonaventureBishopAndDoctor": "San Bonaventura, vescovo e dottore della Chiesa",
    "saintBonifaceBishopAndMartyr": "San Bonifacio, vescovo e martire",
    "saintBridgetOfSwedenReligious": "Santa Brigida, religiosa, patrona d'Europa",
    "saintBrunoPriest": "San Bruno, sacerdote",
    "saintCallistusIPopeAndMartyr": "San Callisto I, papa e martire",
    "saintCamillusDeLellisPriest": "San Camillo de Lellis, sacerdote",
    "saintCasimir": "San Casimiro",
    "saintCatherineOfAlexandriaVirginAndMartyr": "Santa Caterina di Alessandria, vergine e martire",
    "saintCatherineOfSienaVirginAndDoctorOfTheChurch": "Santa Caterina da Siena, vergine e dottore della Chiesa, patrona d'Italia e d'Europa",
    "saintCeciliaVirginAndMartyr": "Santa Cecilia, vergine e martire",
    "saintCharlesBorromeoBishop": "San Carlo Borromeo, vescovo",
    "saintChristopherMagallanesAndCompanionsMartyrs": "Santi Cristoforo Magallanes, sacerdote, e compagni, martiri",
    "saintClareVirgin": "Santa Chiara, vergine",
    "saintClementIPopeAndMartyrSaintColumbanReligious": "San Clemente I, papa e martire / San Colombano, abate",
    "saintCyrilOfAlexandriaBishopAndDoctor": "San Cirillo di Alessandria, vescovo e dottore della Chiesa",
    "saintCyrilOfJerusalemBishopAndDoctor": "San Cirillo di Gerusalemme, vescovo e dottore della Chiesa",
    "saintDamasusIPope": "San Damaso I, papa",
    "saintDenisAndCompanionsMartyrsSaintJohnLeonardiPriest": "San Dionigi, vescovo e compagni, martiri / San Giovanni Leonardi, sacerdote",
    "saintDominicPriest": "San Domenico, sacerdote",
    "saintElizabethOfHungary": "Sant'Elisabetta di Ungheria, religiosa",
    "saintElizabethOfPortugal": "Santa Elisabetta di Portogallo",
    "saintEphremDeaconAndDoctor": "Sant’Efrem, diacono e dottore della Chiesa",
    "saintEusebiusOfVercelliBishopSaintPeterJulianEymardPriest": "Sant'Eusebio di Vercelli, vescovo / San Pietro Giuliano Eymard, sacerdote",
    "saintFidelisOfSigmaringenPriestAndMartyr": "San Fedele da Sigmaringen, sacerdote e martire ",
    "saintFrancesOfRomeReligious": "Santa Francesca Romana, religiosa",
    "saintFrancisDeSalesBishopAndDoctor": "San Francesco di Sales, vescovo e dottore della Chiesa",
    "saintFrancisOfAssisi": "San Francesco d'Assisi, patrono d'Italia",
    "saintFrancisOfPaolaHermit": "San Francesco da Paola, eremita",
    "saintFrancisXavierPriest": "San Francesco Saverio, sacerdote",
    "saintGeorgeMartyrSaintAdalbertBishopAndMartyr": "San Giorgio, martire / Sant'Adalberto, vescovo e martire",
    "saintGregoryTheGreatPopeAndDoctor": "San Gregorio Magno, papa e dottore della Chiesa",
    "saintHedwigReligiousSaintMargaretMaryAlacoqueVirgin": "Santa Edvige, religiosa / Santa Margherita Maria Alacoque, vergine",
    "saintHenryBishopAndMartyr": "Sant'Enrico",
    "saintHilaryOfPoitiersBishopAndDoctor": "Sant’Ilario, vescovo e dottore della Chiesa",
    "saintIgnatiusOfAntiochBishopAndMartyr": "Sant'Ignazio di Antiochia, vescovo e martire",
    "saintIgnatiusOfLoyolaPriest": "Sant'Ignazio di Loyola, sacerdote",
    "saintIrenaeusBishopAndMartyr": "Sant'Ireneo, vescovo e martire",
    "saintIsidoreOfSevilleBishopAndDoctorOfTheChurch": "Sant'Isidoro, vescovo e dottore della Chiesa",
    "saintJamesApostle": "San Giacomo, apostolo",
    "saintJaneFrancesDeChantalReligious": "Santa Giovanna Francesca de Chantal, religiosa",
    "saintJanuariusBishopAndMartyr": "San Gennaro, vescovo e martire",
    "saintJeanVianneyTheCureOfArsPriest": "San Giovanni Maria Vianney, sacerdote",
    "saintJeromeEmilianiSaintJosephineBakhitaVirgin": "San Girolamo Emiliani / Santa Giuseppina Bakhita, vergine",
    "saintJeromePriestAndDoctor": "San Girolamo, sacerdote e dottore della Chiesa",
    "saintJohnBaptistDeLaSallePriest": "San Giovanni Battista de La Salle, sacerdote",
    "saintJohnBoscoPriest": "San Giovanni Bosco, sacerdote",
    "saintJohnChrysostomBishopAndDoctor": "San Giovanni Crisostomo, vescovo e dottore della Chiesa",
    "saintJohnDamascenePriestAndDoctor": "San Giovanni Damasceno, sacerdote e dottore della Chiesa",
    "saintJohnEudesPriest": "San Giovanni Eudes, sacerdote",
    "saintJohnIPopeAndMartyr": "San Giovanni I, papa e martire",
    "saintJohnOfCapistranoPriest": "San Giovanni da Capestrano, sacerdote",
    "saintJohnOfGodReligious": "San Giovanni di Dio, religioso",
    "saintJohnOfKantyPriest": "San Giovanni da Keti, sacerdote",
    "saintJohnOfTheCrossPriestAndDoctor": "San Giovanni della Croce, sacerdote e dottore della Chiesa",
    "saintJohnTheApostleAndEvangelist": "San Giovanni, apostolo ed evangelista",
    "saintJosaphatBishopAndMartyr": "San Giosafat, vescovo e martire",
    "saintJosephTheWorker": "San Giuseppe lavoratore",
    "saintJuanDiegoCuauhtlatoatzin": "San Giovanni Diego Cuauhtlatoatzin",
    "saintJustinMartyr": "San Giustino, martire",
    "saintLawrenceOfBrindisiPriestAndDoctor": "San Lorenzo da Brindisi, sacerdote e dottore della Chiesa",
    "saintLawrenceOfRomeDeaconAndMartyr": "San Lorenzo, diacono e martire",
    "saintLeoTheGreatPopeAndDoctor": "San Leone Magno, papa e dottore della Chiesa",
    "saintLouisSaintJosephOfCalasanzPriest": "San Ludovico / San Giuseppe Calasanzio, sacerdote",
    "saintLucyOfSyracuseVirginAndMartyr": "Santa Lucia, vergine e martire",
    "saintLukeTheEvangelist": "San Luca, evangelista",
    "saintMargaretOfScotlandSaintGertrudeTheGreatVirgin": "Santa Margherita di Scozia / Santa Geltrude, vergine",
    "saintMariaGorettiVirginAndMartyr": "Santa Maria Goretti, vergine e martire",
    "saintMarkTheEvangelist": "San Marco, evangelista",
    "saintMartha": "Santa Marta",
    "saintMartinDePorresReligious": "San Martino di Porres, religioso",
    "saintMartinIPopeAndMartyr": "San Martino I, papa e martire",
    "saintMartinOfToursBishop": "San Martino di Tours, vescovo",
    "saintMaryMagdalene": "Santa Maria Maddalena",
    "saintMatthewApostleAndEvangelist": "San Matteo, apostolo ed evangelista",
    "saintMatthiasTheApostle": "San Mattia, apostolo",
    "saintMaximilianMaryKolbePriestAndMartyr": "San Massimiliano Maria Kolbe, sacerdote e martire",
    "saintMonica": "Santa Monica",
    "saintNicholasBishop": "San Nicola, vescovo",
    "saintNorbertBishop": "San Norberto, vescovo",
    "saintPatrickBishop": "San Patrizio, vescovo",
    "saintPaulinusOfNolaBishopSaintsJohnFisherBishopAndThomasMoreMartyrs": "San Paolino di Nola, vescovo / Santi Giovanni Fisher, vescovo e Tommaso More, martiri",
    "saintPaulMikiAndCompanionsMartyrs": "San Paolo Miki sacerdote e compagni, martiri",
    "saintPeterCanisiusPriestAndDoctor": "San Pietro Canisio, sacerdote e dottore della Chiesa",
    "saintPeterChanelPriestAndMartyrSaintLouisGrignonDeMontfortPriest": "San Pietro Chanel, sacerdote e martire / San Luigi Maria Grignion de Montfort, sacerdote",
    "saintPeterChrysologusBishopAndDoctor": "San Pietro Crisologo, vescovo e dottore della Chiesa",
    "saintPeterClaverPriest": "San Pietro Claver, sacerdote",
    "saintPeterDamianBishopAndDoctorOfTheChurch": "San Pier Damiani, vescovo e dottore della Chiesa",
    "saintPhilipNeriPriest": "San Filippo Neri, sacerdote",
    "saintPioOfPietrelcinaPadrePioPriest": "San Pio da Pietrelcina, sacerdote",
    "saintPiusVPope": "San Pio V, papa",
    "saintPiusXPope": "San Pio X, papa",
    "saintPolycarpBishopAndMartyr": "San Policarpo, vescovo e martire",
    "saintRaymondOfPenyafortPriest": "San Raimondo di Peñafort, sacerdote",
    "saintRitaOfCascia": "Santa Rita da Cascia, religiosa",
    "saintRobertBellarmineBishopAndDoctor": "San Roberto Bellarmino, vescovo e dottore della Chiesa",
    "saintRomualdAbbot": "San Romualdo, abate",
    "saintRoseOfLima": "Santa Rosa da Lima, vergine",
    "saintsAugustineZhaoRongPriestAndCompanionsMartyrs": "Santi Agostino Zhao Rong, sacerdote, e compagni, martiri",
    "saintsBasilTheGreatAndGregoryNazianzenBishopsAndDoctors": "Santi Basilio Magno e Gregorio Nazianzeno, vescovi e dottori della Chiesa",
    "saintsCharlesLwangaAndCompanionsMartyrs": "San Carlo Lwanga e compagni, martiri",
    "saintScholasticaVirgin": "Santa Scolastica, vergine",
    "saintsCorneliusPopeAndCyprianBishopMartyrs": "Santi Cornelio, papa e Cipriano, vescovo, martiri",
    "saintsCosmasAndDamianMartyrs": "Santi Cosma e Damiano, martiri",
    "saintsCyrilMonkAndMethodiusBishop": "Santi Cirillo, monaco e Metodio, vescovo, patroni d'Europa",
    "saintsFabianPopeAndSebastianMartyrs": "San Fabiano, papa, e San Sebastiano, martire",
    "saintCharbelMakhloufPriestAndHermit": "San Charbel Makhluf, sacerdote",
    "saintSixtusIiPopeAndCompanionsMartyrsSaintCajetanPriest": "San Sisto II, papa e compagni, martiri / San Gaetano, sacerdote",
    "saintsJeanDeBrebeufAndIsaacJoguesPriestsAndCompanionsMartyrsSaintPaulOfTheCrossPriest": "Santi Giovanni de Brébeuf e Isacco Jogues, sacerdoti e compagni, martiri / San Paolo della Croce, sacerdote",
    "saintsJoachimAndAnne": "Santi Gioacchino e Anna, genitori della Beata Vergine Maria",
    "saintsMarcellinusAndPeterMartyrs": "Santi Marcellino e Pietro, martiri",
    "saintsMichaelGabrielAndRaphaelArchangels": "Santi Arcangeli Michele, Gabriele e Raffaele",
    "saintsNereusAndAchilleusMartyrsSaintPancrasMartyr": "Santi Nereo e Achilleo, martiri / San Pancrazio, martire",
    "saintsPerpetuaAndFelicityMartyrs": "Sante Perpetua e Felicita, martiri",
    "saintsPhilipAndJamesApostles": "Santi Filippo e Giacomo, apostoli",
    "saintsPontianPopeAndHippolytusPriestMartyrs": "Santi Ponziano, papa e Ippolito, sacerdote, martiri",
    "saintsSimonAndJudeApostles": "Santi Simone e Giuda, apostoli",
    "saintStanislausBishopAndMartyr": "Santo Stanislao, vescovo e martire",
    "saintStephenOfHungary": "Santo Stefano di Ungheria",
    "saintStephenTheFirstMartyr": "Santo Stefano, primo martire",
    "saintsTimothyAndTitusBishops": "Santi Timoteo e Tito, vescovi",
    "saintSylvesterIPope": "San Silvestro I, papa",
    "saintTeresaBenedictaOfTheCrossEdithSteinVirginAndMartyr": "Santa Teresa Benedetta della Croce, vergine e martire, patrona d'Europa",
    "saintTeresaOfJesusVirginAndDoctorOfTheChurch": "Santa Teresa d'Avila, vergine e dottore della Chiesa",
    "saintThereseOfTheChildJesusVirginAndDoctor": "Santa Teresa di Gesu' Bambino, vergine e dottore della Chiesa",
    "saintThomasAquinasPriestAndDoctor": "San Tommaso d'Aquino, sacerdote e dottore della Chiesa",
    "saintThomasBecketBishopAndMartyr": "San Tommaso Becket, vescovo e martire",
    "saintThomasTheApostle": "San Tommaso, apostolo",
    "saintTuribiusOfMogrovejoBishop": "San Turibio de Mogrovejo, vescovo",
    "saintVincentDeaconAndMartyr": "San Vincenzo, diacono e martire",
    "saintVincentDePaulPriest": "San Vincenzo de' Paoli, sacerdote",
    "saintVincentFerrerPriest": "San Vincenzo Ferrer, sacerdote",
    "saintWenceslausMartyrSaintsLawrenceRuizAndCompanionsMartyrs": "San Venceslao, martire / Santi Lorenzo Ruiz e compagni, martiri",
    "sevenHolyFoundersOfTheServiteOrder": "Santi Sette Fondatori dei Servi della Beata Vergine Maria",
    "theBeheadingOfSaintJohnTheBaptistMartyr": "Martirio di San Giovanni Battista",
    "theMostHolyNameOfJesus": "Santissimo Nome di Gesú",
    "visitationOfTheBlessedVirginMary": "Visitazione della Beata Vergine Maria"
  }
};
